// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Contract = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Contract = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Contract = _exports.Contract = function Contract(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 16 16",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.4",
      d: "M12 5.33331V8.14331C12 8.24998 11.9153 8.33264 11.8086 8.33864C9.87659 8.43864 8.33333 10.0447 8.33333 12.0007C8.33333 12.3747 8.38734 12.732 8.49268 13.0693C8.53334 13.2006 8.44334 13.334 8.30534 13.334H4C2.66667 13.334 2 12.6673 2 11.334V3.33398C2 2.00065 2.66667 1.33398 4 1.33398H8V3.33398C8 4.43865 8.89533 5.33398 10 5.33398H12V5.33331Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 5.33301H12L8 1.33301V3.33301C8 4.66634 8.66667 5.33301 10 5.33301Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.33268 7.83301H4.66602C4.39002 7.83301 4.16602 7.60901 4.16602 7.33301C4.16602 7.05701 4.39002 6.83301 4.66602 6.83301H9.33268C9.60868 6.83301 9.83268 7.05701 9.83268 7.33301C9.83268 7.60901 9.60868 7.83301 9.33268 7.83301ZM7.83268 9.99967C7.83268 9.72367 7.60868 9.49967 7.33268 9.49967H4.66602C4.39002 9.49967 4.16602 9.72367 4.16602 9.99967C4.16602 10.2757 4.39002 10.4997 4.66602 10.4997H7.33268C7.60868 10.4997 7.83268 10.2757 7.83268 9.99967Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.5",
      d: "M12.0007 9.33301C10.528 9.33301 9.33398 10.527 9.33398 11.9997C9.33398 13.4723 10.528 14.6663 12.0007 14.6663C13.4733 14.6663 14.6673 13.4723 14.6673 11.9997C14.6673 10.527 13.4733 9.33301 12.0007 9.33301ZM13.07 11.6797L11.9587 12.791C11.896 12.8537 11.8113 12.8883 11.7227 12.8883C11.634 12.8883 11.5493 12.853 11.4867 12.791L10.9313 12.2357C10.8013 12.1057 10.8013 11.8943 10.9313 11.7643C11.0613 11.6343 11.2727 11.6343 11.4027 11.7643L11.722 12.0844L12.5973 11.209C12.7273 11.079 12.9387 11.079 13.0687 11.209C13.1987 11.339 13.2 11.5497 13.07 11.6797Z",
      fill: "currentColor"
    }));
  };
});
